import { Injectable, inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { RIGHT_NAV_TRANSLATION_BASE_PATH } from '~core/components/right-nav-breadcrumb-constants';
import { TranslatePipe } from '~shared/pipes/translate.pipe';
import { AppState } from '~core/states/app/app.state';

@Injectable({
  providedIn: 'root'
})
export class ReportSettingsResolver  {
  private translate = inject(TranslatePipe);
  private appState = inject(AppState);


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {    
    const translatePath = `${RIGHT_NAV_TRANSLATION_BASE_PATH}.DisplayName.Report Settings`;
    
    const translatedTitle = this.translate.transform(translatePath);

    this.appState.set('pageTitle', translatedTitle);
  }
}